(function() {

    'use strict';


    eclipseApp.factory('viewInvoice', function() {

        var dateList = {};
        var epostList = {};
        var britebillLiSt = '';
        var combinedList = {};
        var showMessageBoxDiv = false;

        var activationDate = '';

        function setActivationDate(data) {
            activationDate = data;
        }


        function getActivationDate() {
            return activationDate;
        }

        function getShowMessageBoxDiv() {
            return showMessageBoxDiv;
        }

        function setShowMessageBoxDiv(data) {
            showMessageBoxDiv = data;
        }

        function setDateList(data) {
            dateList = data;
        }

        function getDateList() {
            return dateList;
        }

        function setEpostList(data) {
            epostList = data;
        }

        function getEpostList() {
            return epostList;
        }

        function setBritebillList(data) {
            britebillLiSt = data;
        }

        function getBritebillList() {
            return britebillLiSt;
        }

        function setCombinedList(data) {
            combinedList = data;
        }

        function getCombinedList() {
            return combinedList;
        }

        function clearList() {
            britebillLiSt = dateList = epostList = activationDate = '';
        }


        return {

            setDateList: setDateList,
            getDateList: getDateList,
            setEpostList: setEpostList,
            getEpostList: getEpostList,
            setBritebillList: setBritebillList,
            getBritebillList: getBritebillList,
            setCombinedList: setCombinedList,
            getCombinedList: getCombinedList,
            setActivationDate: setActivationDate,
            getActivationDate: getActivationDate,
            setShowMessageBoxDiv: setShowMessageBoxDiv,
            getShowMessageBoxDiv: getShowMessageBoxDiv,
            clearList: clearList
        }

    });


})();
